import { Drawer, Form, Card, Radio, Select, Input, Divider, Button, DatePicker, TimePicker, Icon, notification, Tag } from "antd";
import React from "react";
import { connect } from "react-redux";
import Request from "../../request";
import _ from 'lodash';
import moment from 'moment';

let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
const RadioGroup = Radio.Group;
const Option = Select.Option;
const { TextArea } = Input;

@Form.create()
class AddAppointmentDrawer extends React.Component {
    state = {
        visible: true,
        allUsers: [],
        filteredData: [],
        FromType: 'Student',
        searchLoading: false,
        studentData: null,
        loading: false
    }

    onClose = () => {
        this.props.form.resetFields();
        this.setState({ studentData: null, filteredData: [] });
        setTimeout(() => {
            this.props.onClose();
        }, 50);
    }

    loadUsers = async () => {
        let activeUser = JSON.parse(localStorage.getItem('user'));
        let params = {
            results: 10000,
            count: 10000,
            sortField: 'name',
            sortOrder: 'ascend',
            userBranch: activeUser ? activeUser.userBranch : null,
            active: true,
            userType: { $ne: "Student" }
        };

        let data = await Request.loadUser({ ...params, regExFilters: ['name', 'email'] });
        let allUsers = [];
        _.each(data.data, (user) => {
            allUsers.push({ _id: user._id, display: user.name });
        });

        this.setState({ allUsers });
    }

    handleSubmit = e => {
        const { form } = this.props;
        const { studentData, allUsers } = this.state;
        e.preventDefault();

        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.cloneDeep(valData);

                // Formatting for Backend
                values.startDate = valData.startDate ? valData.startDate.toISOString() : null;
                values.startTime = valData.startTime ? valData.startTime.format("HH:mm:ss") : null;

                if (values.fromType === 'Student' && studentData) {
                    values.name = studentData.studentName;
                    values.phoneNo = studentData.phoneNo;
                    values.email = studentData.emailId;
                    values.studentId = studentData.id;
                    values.vid = studentData._id;
                } else {
                    values.studentId = 0;
                }

                // Map attendee names for the 'attendees' field
                let attendees = [];
                _.each(values.attendeeIds, (id) => {
                    let user = _.find(allUsers, { _id: id });
                    if (user) attendees.push(user.display);
                });
                values.attendees = attendees;

                this.setState({ loading: true });
                let response = await Request.addAppointment(values);
                this.setState({ loading: false });

                if (response && !response.error) {
                    notification.success({ message: response.msg || 'Appointment Scheduled' });
                    this.onClose();
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: response ? response.msg : 'Unknown Error'
                    });
                }
            }
        });
    }

    componentDidMount() {
        this.loadUsers();
    }

    render() {
        let { visible, allUsers, filteredData, FromType, searchLoading, loading } = this.state;
        let { form: { getFieldDecorator } } = this.props;

        const formItemLayout = {
            labelCol: { span: 7 },
            wrapperCol: { span: 15 }
        };

        return (
            <Drawer
                title={
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '95%' }}>
                        <span>
                            <Icon type="calendar" style={{ marginRight: 10, color: '#1890ff' }} />
                            Schedule New Appointment
                        </span>
                        <Tag
                            color="blue"
                            style={{
                                border: '1px solid #1890ff',
                                borderRadius: '4px',
                                fontWeight: 700,
                                padding: '0 12px'
                            }}
                        >
                            Appointment
                        </Tag>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={visible}
                width={700}
            >
                <Card bordered={true} style={{ borderRadius: '8px' }}>
                    <Form onSubmit={this.handleSubmit} layout="horizontal">

                        <Form.Item {...formItemLayout} label="Appointment For">
                            {getFieldDecorator('fromType', {
                                initialValue: 'Student',
                                rules: [{ required: true }]
                            })(
                                <RadioGroup
                                    options={['Student', 'Other']}
                                    onChange={v => this.setState({ FromType: v.target.value })}
                                />
                            )}
                        </Form.Item>

                        <Divider style={{ margin: '16px 0' }} />

                        {FromType === 'Student' ? (
                            <Form.Item {...formItemLayout} label="Search Student">
                                {getFieldDecorator('studentId', {
                                    rules: [{ required: true, message: 'Please select a student' }]
                                })(
                                    <Select
                                        showSearch
                                        allowClear
                                        loading={searchLoading}
                                        style={{ width: '100%' }}
                                        placeholder={`Search Student by Name, DOB, Mobile or Email`}
                                        filterOption={false}
                                        onSearch={async (test) => {
                                            if (test.length > 2) {
                                                this.setState({ searchLoading: true });
                                                let { data } = await Request.searchStudentFilteredData({ test });
                                                this.setState({ filteredData: data, searchLoading: false });
                                            }
                                        }}
                                        onChange={id => {
                                            let found = _.find(filteredData, (item) => item._id === id);
                                            this.setState({ studentData: found });
                                        }}
                                    >
                                        {filteredData.map((val, idn) => (
                                            <Option key={idn} value={val._id}>
                                                {`${val.studentName} (${val.id}) - ${val.phoneNo}`}
                                            </Option>
                                        ))}
                                    </Select>
                                )}
                            </Form.Item>
                        ) : (
                            <React.Fragment>
                                <Form.Item {...formItemLayout} label="Full Name">
                                    {getFieldDecorator('name', { rules: [{ required: true }] })(<Input placeholder="Enter guest name" />)}
                                </Form.Item>
                                <Form.Item {...formItemLayout} label="Email Address">
                                    {getFieldDecorator('email', { rules: [{ required: true, type: 'email' }] })(<Input placeholder="example@mail.com" />)}
                                </Form.Item>
                                <Form.Item {...formItemLayout} label="Phone Number">
                                    {getFieldDecorator('phoneNo', { rules: [{ required: true }] })(<Input placeholder="9876543210" />)}
                                </Form.Item>
                            </React.Fragment>
                        )}

                        <Form.Item {...formItemLayout} label="Assign Attendees">
                            {getFieldDecorator('attendeeIds', {
                                rules: [{ required: true, message: 'Please assign staff' }]
                            })(
                                <Select
                                    mode="multiple"
                                    style={{ width: '100%' }}
                                    placeholder="Search and select staff"
                                    showSearch
                                    allowClear
                                    optionFilterProp="label"
                                    optionLabelProp="label"
                                >
                                    {allUsers.map(user => (
                                        <Option key={user._id} value={user._id} label={user.display}>
                                            <Icon type="user" style={{ marginRight: 8, color: '#bfbfbf' }} />
                                            {user.display}
                                        </Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>

                        <Divider style={{ margin: '16px 0' }} />

                        <Form.Item {...formItemLayout} label="Location">
                            {getFieldDecorator('location', { rules: [{ required: true }] })(<Input placeholder="e.g. Office, Conference Room" />)}
                        </Form.Item>

                        <Form.Item {...formItemLayout} label="Subject">
                            {getFieldDecorator('subject', { rules: [{ required: true }] })(<TextArea rows={3} placeholder="Notes about the meeting..." />)}
                        </Form.Item>

                        <Form.Item {...formItemLayout} label="Meeting Schedule">
                            <div style={{ display: 'flex', gap: '10px' }}>
                                {getFieldDecorator('startDate', { rules: [{ required: true }] })(
                                    <DatePicker
                                        style={{ flex: 1 }}
                                        format={dateFormat}
                                        disabledDate={current => current && current < moment().startOf('day')}
                                    />
                                )}
                                {getFieldDecorator('startTime', { rules: [{ required: true }] })(
                                    <TimePicker style={{ flex: 1 }} format="HH:mm:ss" />
                                )}
                            </div>
                        </Form.Item>

                        <div style={{ textAlign: 'right', marginTop: 30 }}>
                            <Button onClick={this.onClose} style={{ marginRight: 12, borderRadius: '4px' }}>
                                Cancel
                            </Button>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                                style={{ borderRadius: '4px', fontWeight: 600, padding: '0 24px' }}
                            >
                                <Icon type="save" /> Save Appointment
                            </Button>
                        </div>
                    </Form>
                </Card>
            </Drawer>
        );
    }
}

const mapStateToProps = ({ global }) => ({
    loading: global.buttonLoading
});

export default connect(mapStateToProps)(AddAppointmentDrawer);